var _path, _path2, _path3, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBottom(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7712 18.0374C16.0411 17.5803 -4.30348 47.1067 3.04086 51.7401C8.36371 55.098 16.0149 56.5031 24.9184 56.1965C34.4787 55.8675 39.5628 50.5546 39.5628 50.5546C39.5628 50.5546 15.3735 45.2448 12.3807 35.6545C11.4601 32.7046 11.2633 27.0591 14.5126 20.5868C14.9286 19.7581 15.2262 18.8812 15.7712 18.0374Z",
    fill: "url(#paint0_linear_2_167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5168 56.2248C22.9866 56.2455 58.8613 57.7199 58.776 49.0362C58.7142 42.7429 55.8563 35.5605 50.7739 28.2432C44.9343 19.8356 37.99 19.1232 37.99 19.1232C37.99 19.1232 44.4291 36.0001 42.2175 45.6469C41.8326 47.3269 41.1851 48.7876 40.1955 49.9015C38.0814 52.282 32.3649 56.2326 23.5168 56.2248Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.264 30.6383C52.54 31.0916 36.3415 -0.884884 28.7936 3.40933C23.3231 6.52147 18.4158 12.6497 14.4107 20.6074C9.78337 29.8012 12.5787 36.2537 12.5787 36.2537C12.5787 36.2537 28.7721 17.0472 38.579 19.228C41.6867 19.9189 47.9713 22.9012 52.264 30.6383Z",
    fill: "#DADADA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_167",
    x1: 38.979,
    y1: 51.589,
    x2: 6.51897,
    y2: 33.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBottom);
export default __webpack_public_path__ + "static/media/logoBottom.4b8996d2f2efbffbd2822469250c671a.svg";
export { ForwardRef as ReactComponent };